import { httpsCallable as firebaseHttpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { createCollectionRequests } from "./collectionRequests";

const requests = createCollectionRequests();
const clients = new WeakMap();
let nextClient = 0;

const identityFor = (functions) => {
  try { return getAuth(functions?.app).currentUser?.uid || "anonymous"; }
  catch { return "anonymous"; }
};

export const LEGACY_COLLECTION_UPDATED_EVENT = "legacy-collection-updated";
export const invalidateLegacyCollections = () => requests.invalidate();
export const notifyLegacyCollectionsChanged = (detail) => {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(LEGACY_COLLECTION_UPDATED_EVENT, { detail }));
  else invalidateLegacyCollections();
};

if (typeof window !== "undefined") {
  for (const event of ["learner-quiz-completed", "learner-assessment-reviewed", "legacy-collection-updated"]) {
    window.addEventListener(event, invalidateLegacyCollections);
  }
}

const isRead = (name) => /^(?:get|fetch|read|list|find|resolve|search|check|validate|preview|calculate|calc|has|is|unityGet|unityList|firestoreRead|studentProgressCalc)/i.test(name);

// Preserve the Firebase callable shape at all existing legacy call sites.
// Only collection loading adds bounded transport and concurrent-load sharing.
export function httpsCallable(functions, name, options) {
  const call = firebaseHttpsCallable(functions, name, options);
  if (name === "getSystemDocuments") {
    const validClient = functions && (typeof functions === "object" || typeof functions === "function");
    if (validClient && !clients.has(functions)) clients.set(functions, ++nextClient);
    return (payload) => requests.load(call, payload, {
      clientId: validClient ? clients.get(functions) : "default",
      requestOptions: options,
      getIdentity: () => identityFor(functions),
    });
  }
  if (isRead(name)) return call;
  return async (payload) => {
    const response = await call(payload);
    const operation = String(payload?.operation || payload?.data?.operation || "").toLowerCase();
    if (response?.data?.success !== false && !["read", "fetch", "get", "list", "query"].includes(operation)) {
      notifyLegacyCollectionsChanged({
        callableName: name,
        systemName: payload?.systemName || payload?.data?.systemName || "",
        operation,
      });
    }
    return response;
  };
}
